export const LogoMark = ({ className = "w-9 h-9", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="22" fill="none" stroke="#C18A53" strokeWidth="2.5" />
    <path
      d="M12 26c11 7 29 7 40 0M12 38c11-7 29-7 40 0"
      fill="none"
      stroke={light ? "#F3EFE6" : "#29221D"}
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ light = false, testId = "brand-logo", full = false }) => {
  if (full) {
    return (
      <a href="#top" data-testid={testId} className="flex items-center group">
        <span className="rounded-md bg-[#FBF9F5] flex items-center">
          <img src="/img/logo-full.jpg" alt="Kashmira&Co" className="h-12 md:h-16 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]" />
        </span>
      </a>
    );
  }
  return (
  <a href="#top" data-testid={testId} className="flex items-center gap-3 group">
    <span className={`w-11 h-11 rounded-full overflow-hidden flex items-center justify-center shrink-0 transition-transform duration-700 group-hover:rotate-180 ${light ? "bg-[#FBF9F5]" : "bg-[#F3EFE6]"}`}>
      <img src="/img/logo-mark.png" alt="Logo Kashmira&Co" className="w-full h-full object-cover" />
    </span>
    <span className={`font-serif text-xl tracking-tight ${light ? "text-[#F3EFE6]" : "text-[#1C1917]"}`}>
      Kashmira<span className={light ? "text-[#C18A53]" : "text-[#9A4930]"}>&amp;</span>Co
    </span>
  </a>
  );
};
